import React, {useState} from 'react';
import styled from 'styled-components';
import _uniqueId from 'lodash/uniqueId';

export default function ToggleButton(props) {
    const [id] = useState(_uniqueId('toggle-btn-'));
    return (
        <>
            <Switchinput {...props} type="checkbox" id={id} />
            <Switchlabel htmlFor={id}/>
        </>
    );
}

export const Switchinput = styled.input`
    display:none;

    &:checked + label {background-color: #ffcf19;}
    &:checked + label::before {transform: translate(calc(100vw*(20/375)),-50%);}
`
export const Switchlabel = styled.label`
    position: relative;
    display:inline-block;
    width: calc(100vw*(40/375));
    height: calc(100vw*(22/375));
    border-radius: calc(100vw*(20/375));
    background-color:  rgb(116, 116, 116, 0.4);

    &::before {
        content: '';
        display:block;
        width:  calc(100vw*(20/375));
        height:  calc(100vw*(20/375));
        box-shadow: 0  calc(100vw*(1/375))  calc(100vw*(3/375)) 0 rgba(0, 0, 0, 0.21);
        background-color: #ffffff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);    
        transition : all .4s ease;
        border-radius: 50%;

    }
`
